var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:_vm.classIcon},[(_vm.verMaterial)?_c('em',{class:_vm.classIcon},[_vm._v(_vm._s(_vm.icon))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }